export default "__VITE_ASSET__DQp5KScD__"